import type { HoldingRow } from '../types'

// Every printed value has a size of zero or more, so a holding with no printed value sorts last.
const NO_PRINTED_VALUE_SIZE = -1

const sizeOf = (holding: HoldingRow) =>
  holding.marketValue == null
    ? NO_PRINTED_VALUE_SIZE
    : Math.abs(holding.marketValue)

// Sorted by size, not sign, so a large short position or margin line is not buried at the end.
export const largestFirst = (holdings: HoldingRow[]) =>
  [...holdings].sort((first, second) => sizeOf(second) - sizeOf(first))
